module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAAXNSR0IArs4c6QAAARVJREFUOE+l07FKBDEUBdB7B4fpxFLspkqCP7C9iJVaiaVo4w9Y2QgLsoWNpc2CpYWFiP6BYD8wvITRLxBhsbEZeBJwFlZnlh1Nm9zDTR6h914AWPxhqeoLvfcKoALw2MdQ1U2S6w1wa63d6wN478cAjmaAqqoGdV2PSb5aa3fmga1ACOFZVQcxqKrbzrmHLqQVEJETkhcAPrMsW8vzfFKW5UaSJPckR8aYc5LxzdAKxI2iKGyapm/OuXcR2SIZWyx9tzp1zo3mAk1l7/0ugLufVyB5ZowZdjaIgRDCvqredN1fVWOLVZKHv8YoIgckrxcY6QeA5RlARI5JXi0Qnh6ZAgCeAFz2CcezDTABsNI33AD/+kxfjManIzCHnssAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/image_fill_small.png
// module id = D2hA
// module chunks = 69